<template>
    <b-row class="mt-4">
        <div class="position-fixed d-none d-lg-block col-2" style="z-index: 10">
            <b-list-group v-b-scrollspy class="table-of-contents">
                <b-list-group-item href="#navigation">Navigation</b-list-group-item>
                <b-list-group-item href="#partners">Partners</b-list-group-item>
                <b-list-group-item href="#interactions">Interactions</b-list-group-item>
                <b-list-group-item href="#arousal">Arousal</b-list-group-item>
                <b-list-group-item href="#hud-ui">HUD / UI</b-list-group-item>
                <b-list-group-item href="#vr-features">VR Features</b-list-group-item>
            </b-list-group>
        </div>

        <div class="col-2 d-none d-lg-block"></div>
        <div class="col-12 col-lg-9 ml-3 guide-list">
            <h4 id="navigation" class="mt-0">Navigation</h4>

        </div>
    </b-row>
</template>

<script>
    export default {
        name: "Gameplay"
    }
</script>
